// The collapsed state of a result card (a DS2 Accordion), remembered in localStorage under storageKey.
import useLocalStorage from "../../../hooks/useLocalStorage";

export function useCollapsed(storageKey: string): [boolean, () => void] {
  const [collapsed, setCollapsed] = useLocalStorage(storageKey, false);
  return [collapsed, () => setCollapsed((c) => !c)];
}
